import { Component } from '@angular/core';

@Component({
    selector: 'pdf-find-regexp',
    templateUrl: './pdf-find-regexp.component.html',
    standalone: false
})
export class PdfFindRegExpComponent {}
